import { render, staticRenderFns } from "./ModalRegrasPassaporte.vue?vue&type=template&id=6752e4fb&scoped=true"
import script from "./ModalRegrasPassaporte.vue?vue&type=script&lang=js"
export * from "./ModalRegrasPassaporte.vue?vue&type=script&lang=js"
import style0 from "./ModalRegrasPassaporte.vue?vue&type=style&index=0&id=6752e4fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6752e4fb",
  null
  
)

export default component.exports